export const news_endpoint = process.env.GATSBY_NEWS_ENDPOINT;
export const owned_media_list = process.env.GATSBY_OWNED_MEDIA_LIST;
export const case_study_list = process.env.GATSBY_CASE_STUDY_LIST;